import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/fonts.css'; // Import the fonts
import App from './App';
import {BrowserRouter} from 'react-router-dom';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/Ujjawal-Portfolio">
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </BrowserRouter> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
